export default __webpack_public_path__ + "static/media/epiphone.319bf7e3.svg";